import React from "react";
import OS from "../../assets/images/OS.webp";
import styles from "./OurSchool.module.scss";

const OurSchool = () => {
	return (
		<div className={styles.OurSchool}>
			<img src={OS} alt="" />
			<h2>welcome to our school</h2>
			<span></span>
			<p>
				Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas
				tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
				mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulumem ipsum dolor sit amet,
				consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
				Vestibulum tincidunt sit tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut
				curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit
				amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
				Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed
				maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit Lorem ipsum dolor sit amet, consectetur
				adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum
				tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed
				maecenas tristique tincidunt cras. Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut
				curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit Lorem ipsum
				dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique
				tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut
				curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulumem ipsum dolor sit amet, consectetur
				adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum
				tincidunt sit tincidunt sit{" "}
			</p>

			<p>
				Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas
				tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
				mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulumem ipsum dolor sit amet,
				consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
				Vestibulum tincidunt sit tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut
				curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit
				amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
				Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed
				maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit Lorem ipsum dolor sit amet, consectetur
				adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum
				tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed
				maecenas tristique tincidunt cras. Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut
				curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit Lorem ipsum
				dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique
				tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut
				curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulumem ipsum dolor sit amet, consectetur
				adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum
				tincidunt sit tincidunt sit{" "}
			</p>
		</div>
	);
};

export default OurSchool;
